import React, { useEffect, useState } from 'react';
import './VeiculoseciaHome.scss';
import api from '../../../config/configApi';
import VeiculoseciaCarousel from '../../../components/Veiculosecia/VeiculoseciaCarousel';
import VeiculoseciaVehicleCard from '../../../components/Veiculosecia/VeiculoseciaVehicleCard';
import { Button, Card, Dialog, IconButton, Slide, Typography } from '@mui/material';
import { MdArrowCircleRight, MdClose } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import iveco from '../../../assets/images/brands/Iveco.png';
import librelato from '../../../assets/images/brands/Librelato.jpg';
import mercedes from '../../../assets/images/brands/Mercedes.png';
import randon from '../../../assets/images/brands/Randon.jpg';
import scania from '../../../assets/images/brands/Scania.png';
import volvo from '../../../assets/images/brands/Volvo.png';
import financiamento from '../../../assets/images/home/truck-driver.jpg';
import truck from '../../../assets/images/home/truck-aboutus.png';
import { ParallaxBanner, ParallaxProvider } from 'react-scroll-parallax';
import Slider from 'react-slick';
import { formatKm, formatValor } from '../../../utils/webConstants';
import { FaFacebookSquare, FaInstagramSquare, FaWhatsappSquare } from "react-icons/fa";
import { logClickView } from '../../../services/logService';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function VeiculoseciaHome() {
    const navigate = useNavigate();

    // ESTADOS DOS RECOMENDADOS
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0); // Páginas baseadas em 0 para o backend (offset)
    const pageSize = 16;

    // ESTADOS DAS OFERTAS
    const [offers, setOffers] = useState([]);
    const [offersLoading, setOffersLoading] = useState(true);
    const [offersError, setOffersError] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => {
        setOpenModal(false);
    }

    // RECOMENDADOS
    useEffect(() => {
        const fetchVehicles = async () => {
            try {
                setLoading(true);
                const response = await api.get(`/api/anuncios?status=true&page=${currentPage}&pageSize=${pageSize}`);
                setVehicles(response.data.data);
            } catch (err) {
                const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar veículos.';
                setError(errMessage);
            } finally {
                setLoading(false);
            }
        };

        fetchVehicles();
    }, [currentPage])

    // OFERTAS
    useEffect(() => {
        const fetchOffers = async () => {
            try {
                setOffersLoading(true);
                const response = await api.get('/api/anuncios?status=true&oferta=true&limiteImagens=1');
                setOffers(response.data.data);
                setOpenModal(true);
            } catch (err) {
                const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar ofertas.';
                setOffersError(errMessage);
            } finally {
                setOffersLoading(false);
            }
        }

        fetchOffers();
    }, [])

    const sliderSettings = {
        infinite: false,      // Carrossel infinito
        speed: 500,          // Velocidade da transição
        slidesToShow: 1,     // Mostrar 1 slide por vez
        slidesToScroll: 1,   // Rolar 1 slide por vez
        autoplay: true,     // Não iniciar automaticamente
        autoplaySpeed: 6000, // Se autoplay for true, tempo entre transições
        arrows: true,        // Mostrar setas de navegação (próximo/anterior)
        fade: true,       // Opcional: Transição com fade em vez de slide
        // Adicionar a função beforeChange para atualizar o estado do slide atual        
    };

    const handleClickView = async (veiculoId) => {
        await logClickView(veiculoId);
    }

    return (
        <>
            {!offersLoading && !offersError && (
                <Dialog
                    open={openModal}
                    onClose={handleClose}
                    slots={{
                        transition: Transition
                    }}
                >
                    <div className='p-2'>
                        <IconButton
                            className='position-absolute z-3'
                            style={{ top: '10px', right: '10px' }}
                            onClick={handleClose}
                        >
                            <MdClose />
                        </IconButton>
                        <Slider
                            {...sliderSettings}
                            className='slider__modal'
                        >
                            {offers.map(item => (
                                <Link
                                    to={`/anuncio/${item.id}`}
                                    className='sale'
                                    key={item.id}
                                    onClick={() => handleClickView(item.id)}
                                >
                                    <div className='sale__pic'>
                                        <img className='sale__img'
                                            src={item.imagens[0]?.ftp_url}
                                            alt={item.modelo}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = "/default.jpg";
                                            }}
                                        />
                                    </div>
                                    <div className='sale__content'>
                                        <div className='sale__up'>
                                            <h1 className='sale__title'>OFERTA DO DIA</h1>
                                            <h1 className='sale__title mid'>OFERTA DO DIA</h1>
                                            <h1 className='sale__title'>OFERTA DO DIA</h1>
                                        </div>
                                        <div className='sale__info'>
                                            <h2 className='sale__model'>
                                                {(item.categoria.id === 1 || item.categoria.id === 3) && (
                                                    <>
                                                        {item.marca.nome} {item.modelo}
                                                    </>
                                                )}
                                                {item.categoria.id === 2 && (
                                                    <>
                                                        {item.tipo} {item.marca.nome} {item.modelo}
                                                    </>
                                                )}
                                            </h2>
                                            <span className='sale__desc'>
                                                {item.categoria.id === 1 && `${item.tracao} - `} {item.ano_fabricacao}/{item.ano_modelo} {(item.categoria.id === 1 || item.categoria.id === 3) && ` - ${formatKm(item.km)}`}
                                            </span>
                                        </div>
                                        <div className='sale__price'>
                                            <h1 className='sale__value'>{formatValor(item.valor)}</h1>
                                        </div>
                                        <div className='sale__bottom'>
                                            <div className='sale__social'>
                                                <FaFacebookSquare />
                                                <FaInstagramSquare />
                                                <FaWhatsappSquare />
                                                <div className="sale__contact">
                                                    <span>veiculoseciamt</span>
                                                    <span>(66) 99981-5612</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </Slider>
                    </div>
                </Dialog>
            )}
            <VeiculoseciaCarousel />
            <div className='bg-white'>
                <div className='veiculosecia__content'>
                    <div className='home'>
                        <div className='home__models'>
                            <h6 className='models__title'>Conheça nossos modelos em destaque</h6>
                            <div className='models__line'>
                                <span className='line first'></span>
                                <span className='line second'></span>
                                <span className='line third'></span>
                            </div>

                            <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4'>
                                {loading ? (
                                    <div className='col text-center w-100'>
                                        <Typography variant='h6'>Carregando veículos...</Typography>
                                    </div>
                                ) : error ? (
                                    <div className='col text-center w-100'>
                                        <Typography variant='h6' color='error'>{error}</Typography>
                                    </div>
                                ) : vehicles.length === 0 ? (
                                    <div className='col text-center w-100'>
                                        <Typography variant='h6'>Nenhum veículo encontrado com os filtros aplicados.</Typography>
                                    </div>
                                ) : (
                                    vehicles.map(vehicle => (
                                        <div className='col' key={vehicle.id}>
                                            <VeiculoseciaVehicleCard vehicle={vehicle} />
                                        </div>
                                    ))
                                )}
                            </div>
                            <div className='d-flex justify-content-center mt-4'>
                                <Button
                                    className='models__button'
                                    variant='contained'
                                    endIcon={<MdArrowCircleRight />}
                                    onClick={() => navigate('/estoque')}
                                >
                                    VER ESTOQUE COMPLETO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='home__filter'>
                <div className='veiculosecia__content'>
                    <h6 className='filter__title mb-4'>Filtrar pela <span className='brand__title'>Marca</span></h6>
                    <div className='d-flex align-items-center row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-6 g-5'>
                        <div className='col'>
                            <Card className='brand__card'>
                                <Link to='/estoque?marca=9' className='brand__link'>
                                    <img src={iveco} alt='Iveco' />
                                </Link>
                            </Card>
                        </div>
                        <div className='col'>
                            <Card className='brand__card'>
                                <Link to='/estoque?marca=13' className='brand__link'>
                                    <img src={librelato} alt='Librelato' />
                                </Link>
                            </Card>
                        </div>
                        <div className='col'>
                            <Card className='brand__card'>
                                <Link to='/estoque?marca=15' className='brand__link'>
                                    <img src={mercedes} alt='Mercedes' />
                                </Link>
                            </Card>
                        </div>
                        <div className='col'>
                            <Card className='brand__card'>
                                <Link to='/estoque?marca=21' className='brand__link'>
                                    <img src={randon} alt='Randon' />
                                </Link>
                            </Card>
                        </div>
                        <div className='col'>
                            <Card className='brand__card'>
                                <Link to='/estoque?marca=24' className='brand__link'>
                                    <img src={scania} alt='Scania' />
                                </Link>
                            </Card>
                        </div>
                        <div className='col'>
                            <Card className='brand__card'>
                                <Link to='/estoque?marca=27' className='brand__link'>
                                    <img src={volvo} alt='Volvo' />
                                </Link>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
            <ParallaxProvider>
                <ParallaxBanner
                    layers={[{ image: financiamento, speed: 10 }]}
                    className='home__financiamento aspect-[2/1]'
                >
                    <div className='position-relative inset-0 flex items-center justify-center' style={{ height: '300px' }}>
                        <div className='veiculosecia__content d-flex flex-column justify-content-center h-100'>
                            <h6 className='text-8xl text-white' style={{ fontSize: '20px', fontWeight: 700 }}>Financiamento</h6>
                            <p className='text-white text-break m-0'>
                                A Veículos & Cia - Caminhões e Carretas facilita ao máximo o seu financiamento para proporcionar parcelas que cabem no seu bolso.
                                <Link to='/financiamento' onClick={() => window.scroll(0, 0)}> Saiba+</Link>
                            </p>
                        </div>
                    </div>
                </ParallaxBanner>
            </ParallaxProvider>
            <div id='quem-somos' className='home__about'>
                <div className='veiculosecia__content'>
                    <div className='row align-items-center justify-content-between'>
                        <div className='col-sm-6'>
                            <h6 className='about__title text-white'>Sobre a Veículos & Cia</h6>
                            <p className='about__desc text-white m-0'>
                                Empresa no ramo de venda de veículos com mais de 16 anos de mercado,
                                estabelecida às margens da rodovia BR 364, perímetro urbano do município
                                de JACIARA-MT, atuando no seguimento de veículos pesados, e para melhor
                                atendê-lo, vem inovando a cada dia.
                                Disponibilizando seus veículos em vários sites e redes sociais na internet,
                                como: Facebook, Instagram, WhatsApp e Youtube, para que você cliente receba
                                nossas ofertas. Trabalhamos em parcerias com diversas transportadoras em todo
                                o Brasil, trazendo até você as melhores condições de preços para aquisição de
                                seu veículos pesados. Trabalhamos na venda por unidades ou por lotes, sempre
                                com preço diferenciado e qualidade. Trabalhamos com vários bancos e formas de
                                financiamentos. Disponibilizamos crédito para financiamento do 1° CAMINHÃO,
                                buscamos também as melhores condições de financiamentos para essa linha de
                                crédito. Venha nos visitar, teremos o maior prazer em atender você cliente.
                            </p>
                        </div>
                        <div className='about__image col-sm-4'>
                            <img src={truck} alt='Caminhão' width={'100%'} />
                            <div className='circle__shape'>
                                <p className='text-white'>Mais de 16 anos de mercado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VeiculoseciaHome;